export default "__VITE_ASSET__USdgVnbx__"